import { AuthGuard } from '../../../../../common/services/Auth.guard';
import { OtherComponent } from './other.component';
import { TemplateComponent } from './template/template.component';

export const OtherSettingsRoute = [
  {
    path: 'other',
    component: OtherComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'template', pathMatch: 'full' },
      {
        path: 'template',
        component: TemplateComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/other/other.route.ts